const LoadingBar = () => (
  <div className="fixed top-0 left-0 right-0 z-[100] h-0.5 bg-emerald-100">
    <div className="h-full bg-emerald-500 animate-pulse" style={{ width: '70%', transition: 'width 0.5s' }} />
  </div>
);

export default LoadingBar;
